import React, { useState, useEffect, useCallback, useRef } from "react";
import { waitGridColumnLayOut, incomeGridColumnLayOut } from "./columnLayout";
import { defaultGridProps } from "../../../components/AuiGrid/gridLayout";
import { useAxiosWithAuthorization } from "../../../utils/api";
import AUIGrid from "../../../lib/AuiGrid/AUIGridReact";
import SelectBox from "../../../components/SelectBox";
import { isFieldDisabled } from "../../../utils/validators";
import { ModalReturnListPop } from "../../Popup/ReturnListPop";
import { ModalConfirm } from "../../../components/Confirm";
import { ModalCameraRecordPop } from "../../Popup/CameraRecordPop";
import { ModalCameraSnapshotPop } from "../../Popup/CameraSnapshotPop";
import useAppContext from "../../../utils/Reducers";
import InputBox from "../../../components/InputBox";

const OutgoingWaitList = (props) => {
  const myGrid = useRef();

  const {
    store: { userInfo, menuKey },
  } = useAppContext();

  useEffect(() => {
    const auiGrid = myGrid.current;
    auiGrid.resize(400, 200);
  }, [menuKey]);

  const [state, setState] = useState("normaled");
  const [isFirstRender, setIsFirstRender] = useState(true);

  //추가, 수정일때 항목의 disabled 결정
  const disabledFields = {
    created: [""],
    updated: ["systemCd"],
  };

  const initItem = {
    status: "U",
    systemCd: "",
    inspNo: "",
    inspDt: "",
    plantCd1: "",
    plantCd: "",
    transCd: "",
    vhclNo: "",
    vhclType: "20",
    itemCd: "",
    vndrCd: "",
    vndrNm: "",
    rvndrCd: "",
    rvndrNm: "",
    loadAreaCd: "",
    loadAreaNm: "",
    scrapAreaCd: "",
    scrapAreaNm: "",
    magnet: "",
    dcsnItemCd: "",
    subItemCd1: "",
    subItemPrdCd1: "",
    subItemRate1: "",
    subItemCd2: "",
    subItemPrdCd2: "",
    subItemRate2: "",
    subItemCd3: "",
    subItemPrdCd3: "",
    subItemRate3: "",
    outageCd: "",
    outageWght: "",
    outageRsn: "",
    returnCd: "",
    returnWght: "",
    returnRsn: "",
    dprctCd: "",
    dprctRate: "",
    scalNo: "",
    tmsOdrNo: "",
    workerId: "",
    inspCd: "R",
    rmks: "",
    inptDt: "",
    totalWeight: "",
    dcsnDesc: "",
    dcsnItemScoreCd: "",
    bfDcsnItemScoreNm: "",
  };

  const [fieldValues, setFieldValues] = useState(initItem);

  //코드 및 그리드 초기화 및 생성
  useEffect(() => {
    const auiGrid = myGrid.current;

    auiGrid.bind("cellClick", function (event) {
      gridCellClick(event.item);
    });
    //
  }, []);

  //코드 및 그리드 초기화 및 생성
  useEffect(() => {
    console.log(props.primaryParameters.schPlantCd);
    if (
      props.primaryParameters.schPlantCd !== "" &&
      props.primaryParameters.schPlantCd !== null
    )
      searchOutgoingWait();
    //
  }, [props.primaryParameters.schPlantCd]);

  const gridCellClick = (item) => {
    // 추가 : editable, 수정 : edtiable, 삭제 : readonly
    //read
    //setFieldsEnabled(auiGrid, item, disabledFields);
    setFieldValues(initItem);
    const auiGrid = myGrid.current;
    if (auiGrid.isAddedById(item._$uid)) {
      setState("created");
    } else if (auiGrid.isEditedById(item._$uid)) {
      setState("updated");
    } else if (auiGrid.isRemovedById(item._$uid)) {
      setState("deleted");
    } else {
      setState("updated");
    }
    if (item.inspNo === null) {
      item.status = "C";
      item.inspNo = item.wssId;
    } else {
      item.status = "U";
    }

    setIsFirstRender(true);

    setFieldValues(item);

    setIsFirstRender(false);

  };

  const SEARCH_OUTGOINGWAITLIST_URL =
    "/inspection/video/searchOutgoingWaitList.do";

  const SAVE_INSPECTION_PROGRESS_URL =
    "/inspection/video/saveInspectionProgress.do";

  const [, fetchData] = useAxiosWithAuthorization(
    {
      url: SEARCH_OUTGOINGWAITLIST_URL,
    },
    { manual: true }
  );

  const searchOutgoingWait = async () => {
    const auiGrid = myGrid.current;
    auiGrid.showAjaxLoader();
    const {
      data: { data },
    } = await fetchData({
      url: SEARCH_OUTGOINGWAITLIST_URL,
      params: {
        plantCd: props.primaryParameters.schPlantCd,
      },
    });
    auiGrid.setGridData(data);
    setFieldValues(initItem);
    setState("normaled");
    auiGrid.removeAjaxLoader();
  };

  const SEARCH_SCORE_GRADE_URL = "/inspection/video/searchScoreGrade.do";
  const fetchScoreGrade = async (isFirst) => {
    const rate1 = fieldValues.subItemCd1 ? parseInt(fieldValues.subItemRate1) || 0 : 0;
    const rate2 = fieldValues.subItemCd2 ? parseInt(fieldValues.subItemRate2) || 0 : 0;
    const rate3 = fieldValues.subItemCd3 ? parseInt(fieldValues.subItemRate3) || 0 : 0;

    const total = rate1 + rate2 + rate3;

    if (total === 100) {
      // setLoading(true);

      try {
        const {
          data: {data},
        } = await fetchData({
          url: SEARCH_SCORE_GRADE_URL,
          params: {
            systemCd :   fieldValues.systemCd,
            subItemCd1 : fieldValues.subItemCd1,
            subItemCd2 : fieldValues.subItemCd2,
            subItemCd3 : fieldValues.subItemCd3,
            subItemRate1 : rate1,
            subItemRate2 : rate2,
            subItemRate3 : rate3
          },
          method: "POST",
        });
        console.log("Fetch result:", data);

        if (data && data.length > 0 && data[0].detlCd) {
          // If data exists and is valid, set the dcsnItemCd
          if(isFirst){
            setFieldValues({
              ...fieldValues,
              dcsnItemScoreCd: data[0].detlCd,
              dcsnDesc: `${data[0].score}`
            });
          }else{
            setFieldValues({
              ...fieldValues,
              dcsnItemCd: data[0].detlCd, // Set dcsnItemCd to the fetched value
              dcsnItemScoreCd: data[0].detlCd,
              dcsnDesc: `${data[0].score}`
            });
          }

        } else {
          // If no valid data, reset dcsnItemCd
          setFieldValues({
            ...fieldValues,
            dcsnItemCd: '', // Reset dcsnItemCd to an empty string
            dcsnItemScoreCd: '', // Reset dcsnItemCd to an empty string
            dcsnDesc: '', // Reset dcsnItemCd to an empty string
          });
        }
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    }else{
      setFieldValues({
        ...fieldValues,
        dcsnItemCd: '', // Reset dcsnItemCd to an empty string
        dcsnItemScoreCd: '',
        dcsnDesc: '', // Reset dcsnItemCd to an empty string
      });
    }

  }

  useEffect(() => {
    console.log("초기 렌더링 완료!");
  }, []);

  useEffect(() => {

    if(isFirstRender){

      console.log(fieldValues.subItemPrdCd1)

      const itemCd = fieldValues.dcsnItemNm;

      setFieldValues({
        ...fieldValues,
        bfDcsnItemScoreNm: itemCd
        // dcsnDesc: `${data[0].score}`
      });

      // return;
      fetchScoreGrade(true);
    }else {

      fetchScoreGrade(false);
    }
  }, [fieldValues.subItemRate1, fieldValues.subItemRate2, fieldValues.subItemRate3, fieldValues.subItemCd1, fieldValues.subItemCd2, fieldValues.subItemCd3]);

  const onReturnClick = (e) => {
    ModalReturnListPop({
      vhclNo: fieldValues.vhclNo,
      odrType: "50",
    });
  };

  const handleChangeField = useCallback((event) => {
    //console.log(fieldValues);
    const { name, value } = event.target;
    //console.log("name = " + name + " || value = " + value);
    if (name === "scrapAreaCd") {
      var scrapAreaNm = event.target.options[event.target.selectedIndex].text;
      setFieldValues({
        ...fieldValues,
        [name]: value,
        ["scrapAreaNm"]: scrapAreaNm,
      });
    } else {
      setFieldValues({
        ...fieldValues,
        [name]: value,
      });
    }
  });

  const handleMasterSave = async () => {
    //console.log(fieldValues);
    if (
      await ModalConfirm({
        title: "저장",
        description: "데이터를 저장하시겠습니까?",
      })
    ) {
      let totalRate =
        (fieldValues.subItemRate1 === "" || fieldValues.subItemRate1 === null
          ? 0
          : parseInt(fieldValues.subItemRate1)) +
        (fieldValues.subItemRate2 === "" || fieldValues.subItemRate2 === null
          ? 0
          : parseInt(fieldValues.subItemRate2)) +
        (fieldValues.subItemRate3 === "" || fieldValues.subItemRate3 === null
          ? 0
          : parseInt(fieldValues.subItemRate3));

      //console.log(fieldValues);

      if (fieldValues.scrapAreaCd === "" || fieldValues.scrapAreaCd === null) {
        ModalConfirm({
          title: "필수항목체크 ",
          description: "하차지를 선택하지 않았습니다. ",
          type: "alert",
        });
        return;
      }

      if (fieldValues.dcsnItemCd === "" || fieldValues.dcsnItemCd === null) {
        ModalConfirm({
          title: "필수항목체크 ",
          description: "검수등급을 선택하지 않았습니다. ",
          type: "alert",
        });
        return;
      }

      if (totalRate !== 100) {
        ModalConfirm({
          title: "비율합계 오류",
          description: "세부품목비율 합계가 100%가 아닙니다. 다시 입력하세요..",
        });
        return;
      }

      let total11 =
        fieldValues.subItemCd1 === "" || fieldValues.subItemCd1 === null
          ? 0
          : parseInt(fieldValues.subItemCd1);
      let total12 =
        fieldValues.subItemPrdCd1 === "" || fieldValues.subItemPrdCd1 === null
          ? 0
          : parseInt(fieldValues.subItemPrdCd1);
      let total13 =
        fieldValues.subItemRate1 === "" || fieldValues.subItemRate1 === null
          ? 0
          : parseInt(fieldValues.subItemRate1);

      if (total11 === 0 || total12 === 0 || total13 === 0) {
        ModalConfirm({
          title: "필수항목체크",
          description: "세부등급1, 세부품목1, 세부비율1은 필수항목입니다. ",
        });
        return;
      }

      if (
        (total11 === 0 && total12 === 0 && total13 === 0) ||
        (total11 > 0 && total12 > 0 && total13 > 0)
      ) {
      } else {
        ModalConfirm({
          title: "비율합계 선택",
          description:
            "세부등급1, 세부품목1, 세부비율1 중 선택하지 않은 항목이 있습니다. ",
        });
        return;
      }

      let total21 =
        fieldValues.subItemCd2 === "" || fieldValues.subItemCd2 === null
          ? 0
          : parseInt(fieldValues.subItemCd2);
      let total22 =
        fieldValues.subItemPrdCd2 === "" || fieldValues.subItemPrdCd2 === null
          ? 0
          : parseInt(fieldValues.subItemPrdCd2);
      let total23 =
        fieldValues.subItemRate2 === "" || fieldValues.subItemRate2 === null
          ? 0
          : parseInt(fieldValues.subItemRate2);

      if (
        (total21 === 0 && total22 === 0 && total23 === 0) ||
        (total21 > 0 && total22 > 0 && total23 > 0)
      ) {
      } else {
        ModalConfirm({
          title: "비율합계 선택",
          description:
            "세부등급2, 세부품목2, 세부비율2 중 선택하지 않은 항목이 있습니다. ",
        });
        return;
      }

      let total31 =
        fieldValues.subItemCd3 === "" || fieldValues.subItemCd3 === null
          ? 0
          : parseInt(fieldValues.subItemCd3);
      let total32 =
        fieldValues.subItemPrdCd3 === "" || fieldValues.subItemPrdCd3 === null
          ? 0
          : parseInt(fieldValues.subItemPrdCd3);
      let total33 =
        fieldValues.subItemRate3 === "" || fieldValues.subItemRate3 === null
          ? 0
          : parseInt(fieldValues.subItemRate3);

      if (
        (total31 === 0 && total32 === 0 && total33 === 0) ||
        (total31 > 0 && total32 > 0 && total33 > 0)
      ) {
      } else {
        ModalConfirm({
          title: "비율합계 선택",
          description:
            "세부등급3, 세부품목3, 세부비율3 중 선택하지 않은 항목이 있습니다. ",
        });
        return;
      }

      if (
        fieldValues.outageWght === "" ||
        fieldValues.outageWght === null ||
        fieldValues.outageWght === undefined
      ) {
      } else {
        if (
          fieldValues.outageRsn === "" ||
          fieldValues.outageRsn === null ||
          fieldValues.outageRsn === undefined
        ) {
          alert("감량사유를 선택하지 않았습니다. ");
          return;
        }
      }

      if (
        fieldValues.returnCd === "" ||
        fieldValues.returnCd === null ||
        fieldValues.returnCd === undefined
      ) {
      } else {
        if (
          fieldValues.returnRsn === "" ||
          fieldValues.returnRsn === null ||
          fieldValues.returnRsn === undefined
        ) {
          alert("반품사유를 선택하지 않았습니다. ");
          return;
        }
      }
      if (fieldValues.systemCd === "DH") {
        if (
          fieldValues.dprctRate === "" ||
          fieldValues.dprctRate === null ||
          fieldValues.dprctRate === undefined
        ) {
        } else {
          if (
            fieldValues.dprctCd === "" ||
            fieldValues.dprctCd === null ||
            fieldValues.dprctCd === undefined
          ) {
            alert("감가내역를 선택하지 않았습니다. ");
            return;
          }
        }
      }
      const {
        data: { data },
      } = await fetchData({
        url: SAVE_INSPECTION_PROGRESS_URL,
        data: fieldValues,
        method: "POST",
      });
      ModalConfirm({
        title: "검수저장",
        description: "데이터가 저장되었습니다. ",
      });

      setState("normaled");
      searchOutgoingWait();
    }
  };

  const searchReplay = (e) => {
    ModalCameraRecordPop({ inspNo: fieldValues.inspNo });
  };

  const searchSnapshot = (e) => {
    ModalCameraSnapshotPop({ inspNo: fieldValues.inspNo });
  };

  return (
    <>
      <div className="table_list on">
        <div className="searchdata">
          <ul className="displays">
            <li>
              <button
                type="button"
                className="btn_orenge updown0"
                onClick={searchOutgoingWait}
                style={{ width: "100px" }}
              >
                새로고침
              </button>

              <button
                type="button"
                className="btn_orenge updown0"
                onClick={searchReplay}
                style={{ width: "100px" }}
              >
                동영상확인
              </button>

              <button
                type="button"
                className="btn_orenge updown0"
                onClick={searchSnapshot}
                style={{ width: "100px" }}
              >
                스냅샷확인
              </button>
            </li>
          </ul>
        </div>

        <AUIGrid
          ref={myGrid}
          columnLayout={waitGridColumnLayOut}
          gridProps={{
            ...defaultGridProps,
            rowStyleFunction: function (rowIndex, item) {
              if (item.dcsnItemCd === null) {
                return "my-row-style";
              }
              return "";
            },
            width: 400,
            height: 200,
          }}
        />
      </div>
      <div className="table_list on">
        <ul className="t_form">
          <li className="half">
            <div className="title2">사전등급</div>
            <div className="formbox">
              <SelectBox
                mastCd="TRANS_CD"
                id="transCd"
                name="transCd"
                disabled={true}
                topSelected="선택"
                value={fieldValues.transCd}
                className="ip2"
              />
            </div>
          </li>
          <li className="half">
            <div className="formbox">
              <SelectBox
                mastCd="ITEM_CD"
                id="itemCd"
                name="itemCd"
                disabled={true}
                topSelected="선택"
                value={fieldValues.itemCd}
                className="ip2"
              />
            </div>
            <div className="formbox">
              <input
                type="button"
                disabled={isFieldDisabled(state, "vhclNo", disabledFields)}
                className="btn_ip"
                onClick={fieldValues.returnCnt > 0 ? onReturnClick : ""}
                value="경고/반품"
                style={
                  fieldValues.returnCnt > 0 ? { background: "#e84444" } : {}
                }
              />
            </div>
          </li>
          <li className="">
            <div className="title2">차량번호</div>
            <div className="ip_sup3">
              <div>
                <input
                  type="text"
                  id="vhclNo"
                  name="vhclNo"
                  disabled={true}
                  value={fieldValues.vhclNo}
                  className="ip2"
                />
              </div>
              <div>
                <SelectBox
                  mastCd="VHCL_TYPE"
                  id="vhclType"
                  name="vhclType"
                  topSelected="선택"
                  disabled={isFieldDisabled(state, "vhclType", disabledFields)}
                  onChange={handleChangeField}
                  value={fieldValues.vhclType}
                  className="ip2"
                />
              </div>
            </div>
          </li>
          <li className="half">
            <div className="title2">공급업체</div>
            <div className="formbox">
              <input
                type="text"
                id="vndrNm"
                name="vndrNm"
                disabled={true}
                value={fieldValues.vndrNm}
                className="ip2"
              />
            </div>
          </li>
          <li className="half">
            <div className="title2">실공급업체</div>
            <div className="formbox">
              <input
                type="text"
                id="rvndrNm"
                name="rvndrNm"
                disabled={true}
                value={fieldValues.rvndrNm}
                className="ip2"
              />
            </div>
          </li>
          <li className="half">
            <div className="title2">하차지</div>
            <div className="formbox">
              <div>
                <SelectBox
                  mastCd="SCRAP_AREA_CD"
                  id="scrapAreaCd"
                  name="scrapAreaCd"
                  topSelected="선택"
                  disabled={isFieldDisabled(
                    state,
                    "scrapAreaCd",
                    disabledFields
                  )}
                  attr1={fieldValues.plantCd}
                  onChange={handleChangeField}
                  value={fieldValues.scrapAreaCd}
                  className="ip2"
                />
              </div>
            </div>
          </li>
          <li className="half">
            <div className="title2">검수원</div>
            <div className="formbox">
              <div>
                <input
                  type="text"
                  id="workNm"
                  name="workNm"
                  disabled={true}
                  value={userInfo.nmKor}
                  className="ip2"
                />
              </div>
            </div>
          </li>
          <li className="half">
            <div className="title2">입차일시</div>
            <div className="formbox">
              <input
                type="text"
                id="wghtDt"
                name="wghtDt"
                topSelected="선택"
                disabled="true"
                value={fieldValues.wghtDt}
                className="ip2"
              />
            </div>
          </li>
          <li className="half">
            <div className="title2">총중량</div>
            <div className="formbox">
              <input
                type="text"
                id="totalWeight"
                name="totalWeight"
                disabled="true"
                value={fieldValues.totalWeight}
                className="ip2"
              />
            </div>
          </li>
          <li className="half">
            <div className="title2">스코어등급</div>
            <div className="formbox">
              <SelectBox
                  mastCd="ITEM_CD"
                  id="dcsnItemScoreCd"
                  name="dcsnItemScoreCd"
                  topSelected="선택"
                  disabled={true}
                  onChange={handleChangeField}
                  value={
                    fieldValues.dcsnItemScoreCd !== null ? fieldValues.dcsnItemScoreCd : ""
                  }
                  className="ip2"
              />
            </div>
          </li>
          <li className="half">
            <div className="title2">스코어</div>
            <div className="formbox">
              <input
                  type="text"
                  id="dcsnDescText"
                  name="dcsnDescText"
                  value={fieldValues.dcsnDesc}
                  disabled={true}
                  className="ip2"
              />
            </div>
          </li>
          <li className="half">
            <div className="title2">검수등급</div>
            <div className="formbox">
              <SelectBox
                  mastCd="ITEM_CD"
                  id="dcsnItemCd"
                  name="dcsnItemCd"
                  topSelected="선택"
                  disabled={isFieldDisabled(state, "dcsnItemCd", disabledFields)}
                  onChange={handleChangeField}
                  value={
                    fieldValues.dcsnItemCd !== null ? fieldValues.dcsnItemCd : ""
                  }
                  className="ip2"
              />
            </div>
          </li>
          <li className="half">
            <div className="title2">검수원입력</div>
            <div className="formbox">
              <input
                  type="text"
                  id="bfDcsnItemScoreNm"
                  name="bfDcsnItemScoreNm"
                  value={fieldValues.bfDcsnItemScoreNm}
                  disabled={true}
                  className="ip2"
              />
            </div>
          </li>
        </ul>
        <table className="t_greyth">
          <tr>
            <th>등급</th>
            <th>품목</th>
            <th>비율</th>
          </tr>
          <tr className="t_slider">
            <td>
              <SelectBox
                mastCd="ITEM_CD"
                id="subItemCd1"
                name="subItemCd1"
                disabled={isFieldDisabled(state, "subItemCd1", disabledFields)}
                topSelected="선택"
                onChange={handleChangeField}
                value={
                  fieldValues.subItemCd1 !== null ? fieldValues.subItemCd1 : ""
                }
                className="ip2"
              />
            </td>
            <td>
              <SelectBox
                mastCd="ITEM_PRD_CD"
                id="subItemPrdCd1"
                name="subItemPrdCd1"
                disabled={isFieldDisabled(
                  state,
                  "subItemPrdCd1",
                  disabledFields
                )}
                topSelected="선택"
                onChange={handleChangeField}
                attr1={fieldValues.subItemCd1}
                value={
                  fieldValues.subItemPrdCd1 !== null
                    ? fieldValues.subItemPrdCd1
                    : ""
                }
                className="ip2"
              />
            </td>
            <td>
              <SelectBox
                mastCd="ITEM_RATE"
                id="subItemRate1"
                name="subItemRate1"
                disabled={isFieldDisabled(
                  state,
                  "subItemRate1",
                  disabledFields
                )}
                topSelected="선택"
                onChange={handleChangeField}
                value={
                  fieldValues.subItemRate1 !== null
                    ? fieldValues.subItemRate1
                    : ""
                }
                className="ip2"
              />
            </td>
          </tr>
          <tr className="t_slider">
            <td>
              <SelectBox
                mastCd="ITEM_CD"
                id="subItemCd2"
                name="subItemCd2"
                disabled={isFieldDisabled(state, "subItemCd2", disabledFields)}
                topSelected="선택"
                onChange={handleChangeField}
                value={
                  fieldValues.subItemCd2 !== null ? fieldValues.subItemCd2 : ""
                }
                className="ip2"
              />
            </td>
            <td>
              <SelectBox
                mastCd="ITEM_PRD_CD"
                id="subItemPrdCd2"
                name="subItemPrdCd2"
                disabled={isFieldDisabled(
                  state,
                  "subItemPrdCd2",
                  disabledFields
                )}
                topSelected="선택"
                onChange={handleChangeField}
                attr1={fieldValues.subItemCd2}
                value={
                  fieldValues.subItemPrdCd2 !== null
                    ? fieldValues.subItemPrdCd2
                    : ""
                }
                className="ip2"
              />
            </td>
            <td>
              <SelectBox
                mastCd="ITEM_RATE"
                id="subItemRate2"
                name="subItemRate2"
                disabled={isFieldDisabled(
                  state,
                  "subItemRate2",
                  disabledFields
                )}
                topSelected="선택"
                onChange={handleChangeField}
                value={
                  fieldValues.subItemRate2 !== null
                    ? fieldValues.subItemRate2
                    : ""
                }
                className="ip2"
              />
            </td>
          </tr>
          <tr className="t_slider">
            <td>
              <SelectBox
                mastCd="ITEM_CD"
                id="subItemCd3"
                name="subItemCd3"
                disabled={isFieldDisabled(state, "subItemCd3", disabledFields)}
                topSelected="선택"
                onChange={handleChangeField}
                value={
                  fieldValues.subItemCd3 !== null ? fieldValues.subItemCd3 : ""
                }
                className="ip2"
              />
            </td>
            <td>
              <SelectBox
                mastCd="ITEM_PRD_CD"
                id="subItemPrdCd3"
                name="subItemPrdCd3"
                disabled={isFieldDisabled(
                  state,
                  "subItemPrdCd3",
                  disabledFields
                )}
                topSelected="선택"
                onChange={handleChangeField}
                attr1={fieldValues.subItemCd3}
                value={
                  fieldValues.subItemPrdCd3 !== null
                    ? fieldValues.subItemPrdCd3
                    : ""
                }
                className="ip2"
              />
            </td>
            <td>
              <SelectBox
                mastCd="ITEM_RATE"
                id="subItemRate3"
                name="subItemRate3"
                disabled={isFieldDisabled(
                  state,
                  "subItemRate3",
                  disabledFields
                )}
                topSelected="선택"
                onChange={handleChangeField}
                value={
                  fieldValues.subItemRate3 !== null
                    ? fieldValues.subItemRate3
                    : ""
                }
                className="ip2"
              />
            </td>
          </tr>
        </table>
        <ul className="t_form">
          <li className="half">
            <div className="title2">감량</div>
            <div className="formbox">
              <SelectBox
                mastCd="OUTAGE_WGHT"
                id="outageWght"
                name="outageWght"
                topSelected="선택"
                disabled={isFieldDisabled(state, "outageWght", disabledFields)}
                onChange={handleChangeField}
                value={
                  fieldValues.outageWght !== null ? fieldValues.outageWght : ""
                }
                className="ip2"
              />
            </div>
          </li>
          <li className="half">
            <div className="title2">사유</div>
            <div className="formbox">
              <SelectBox
                mastCd="OUTAGE_CD"
                id="outageRsn"
                name="outageRsn"
                topSelected="선택"
                disabled={isFieldDisabled(state, "outageRsn", disabledFields)}
                onChange={handleChangeField}
                value={
                  fieldValues.outageRsn !== null ? fieldValues.outageRsn : ""
                }
                className="ip2"
              />
            </div>
          </li>
          <li className="half">
            <div className="title2">반품/경고</div>
            <div className="formbox">
              <SelectBox
                mastCd="RETURN_CD"
                id="returnCd"
                name="returnCd"
                topSelected="선택"
                disabled={isFieldDisabled(state, "returnCd", disabledFields)}
                onChange={handleChangeField}
                value={
                  fieldValues.returnCd !== null ? fieldValues.returnCd : ""
                }
                className="ip2"
              />
            </div>
          </li>
          <li className="half">
            <div className="title2">사유</div>
            <div className="formbox">
              <SelectBox
                mastCd="OUTAGE_CD"
                id="returnRsn"
                name="returnRsn"
                topSelected="선택"
                disabled={isFieldDisabled(state, "returnRsn", disabledFields)}
                onChange={handleChangeField}
                value={
                  fieldValues.returnRsn !== null ? fieldValues.returnRsn : ""
                }
                className="ip2"
              />
            </div>
          </li>
          <li className="half">
            <div className="title2">감가비율</div>
            <div className="formbox">
              <SelectBox
                mastCd="ITEM_RATE"
                id="dprctRate"
                name="dprctRate"
                disabled={
                  fieldValues.systemCd === "DH"
                    ? true
                    : isFieldDisabled(state, "dprctRate", disabledFields)
                }
                topSelected="선택"
                onChange={handleChangeField}
                value={
                  fieldValues.dprctRate !== null ? fieldValues.returnRsn : ""
                }
                className="ip2"
              />
            </div>
          </li>
          <li className="half">
            <div className="title2">감가내역</div>
            <div className="formbox">
              <SelectBox
                mastCd="DPRCT_CD"
                id="dprctCd"
                name="dprctCd"
                topSelected="선택"
                disabled={
                  fieldValues.systemCd === "DH"
                    ? true
                    : isFieldDisabled(state, "dprctCd", disabledFields)
                }
                onChange={handleChangeField}
                value={fieldValues.dprctCd !== null ? fieldValues.dprctCd : ""}
                className="ip2"
              />
            </div>
          </li>
        </ul>

        <button
          style={{ width: "100%", height: "60px", borderRadius: "10px" }}
          className="btn_greystyle"
          onClick={handleMasterSave}
        >
          검수저장
        </button>
      </div>
    </>
  );
};
export default OutgoingWaitList;
